export default {
  'SET_AUTH_DATA'(state, data) {
    state.authData = data;
  },
  'SET_LAST_COOKIE_CHECK'(state, timestamp) {
    state.lastCookieCheck = parseInt(timestamp);
  },
  'SET_USER_DATA'(state, data) {
    state.userData = data;
  },
  'SET_RESTARTING'(state, data) {
    state.restarting = data;
  },
  'SET_DUMP_FILES'(state, data) {
    state.dumpFiles = data;
  },
  'SET_FLAGS'(state, data) {
    state.flags = data;
  },
  'SET_MQTT_CONNECTED'(state, flag) {
    state.mqttConnected = flag;
  },
  'DELETE_BACKUP'(state, fileName) {
    state.dumpFiles = state.dumpFiles.filter(item => {
      return item !== fileName;
    });
  },
  'SET_USER_LIST'(state, data) {
    state.userList = data;
  },
  'SET_USER_PDS'(state, data) {
    const { userId, list } = data;
    state.userList = state.userList.map(item => {
      if (parseInt(item.id, 10) === parseInt(userId, 10)) {
        return {
          ...item,
          pds: list
        };
      }

      return item;
    });
  }
};